import React, { useEffect, useRef, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { useHistory, useLocation } from 'react-router-dom'
import Api from '../../../../_helpers/Api'
import Dropdown from '../../../partials/Dropdown'
import { fromInfo, trans } from '../../../../_providers/Translation'
import Help from '../../../partials/Help'
import CustomerTypeFilter from './CustomerTypeFilter'
import { createPortal } from 'react-dom'
import DateRange from '@/components/partials/DateRange'

function Filter(props) {
    const history = useHistory()
    const location = useLocation()

    const vansDropdownRef = useRef(null)
    const categoriesDropdownRef = useRef(null)
    const suppliersDropdownRef = useRef(null)
    const storagesDropdownRef = useRef(null)
    const boxesDropdownRef = useRef(null)

    const handleCategory = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            props.handleSearch('category_id', val)
        }

    }

    const handleSupplier = data => {

        let val = data.id || ''

        if (data.id || data.name === '') {
            props.handleSearch('supplier_id', val)
        }

    }

    const handleStorage = data => {

        let val = data.id || ''

        if (data.id || data.name === '') {
            props.handleSearch('storage_id', val)
        }

    }

    const handleBox = data => {

        let val = data.name || ''

        props.handleSearch('box', val)

    }

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleFilter = (e, k, v) => {
        e.preventDefault()

        if (k === 'customer_type') {
            if (v === '') {
                props.handleSearch('status_id', '')
            }
        }

        props.handleSearch(k, v)
    }

    const handlePosition = (e, v) => {
        e.preventDefault()

        history.push('/parts/storage/' + v)
    }

    const handleVan = data => {

        let val = data.id || ''

        if (data.id || data.name === '') {
            props.handleSearch('van_id', val)
        }

    }

    const toggleSummaryData = bool => {
        props.handleSearch('summary', Number(bool), 0)
    }

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    function handleClearFilters() {
        if (props.filter.stock === 'van') {
            vansDropdownRef.current.reset()
            props.handleSearch('van_id', '')
            history.push('/parts/storage/' + 'van-used')
        }

        props.handleSearch('name', '')
        props.handleSearch('category_id', '')
        props.handleSearch('supplier_id', '')

        categoriesDropdownRef.current.reset()
        suppliersDropdownRef.current.reset()

        if (props.showDates) {
            props.handleSearch('start', '')
            props.handleSearch('end', '')
        }

        if (props.filter.stock === 'office' || props.filter.stock === 'appliances') {
            storagesDropdownRef.current.reset()
            boxesDropdownRef.current.reset()
            props.handleSearch('storage_id', '')
            props.handleSearch('box', '')
        }
    }

    return (
        <form className="filter-standard">
            {props.filter.stock === 'van'
                ?
                <div className='col'>
                    <select
                        value={props.filter.instock === '1' ? 'van' : 'van-used'}
                        onChange={e => handlePosition(e, e.target.value)}
                    >
                        <option value="van-used">
                            {trans('labels.used')}
                        </option>
                        <option value="van">
                            {trans('labels.notUsed')}
                        </option>
                    </select>
                </div>
                :
                ''
            }
            {props.filter.stock === 'van'
                ?
                <div className="col">

                    <Dropdown
                        inputIdName="van_id"
                        inputIdValue={Number(props.filter.van_id)}
                        inputPlaceholder={trans('labels.van')}
                        url="vans/all"
                        renderText={data => {
                            return `${data.reg_no} ${data.employee ? `(${data.employee.name})` : ''}`
                        }}
                        onChange={handleVan}
                        ref={vansDropdownRef}
                    />

                </div>
                :
                ''
            }
            {props.showStatuses && document.querySelector('.mini-tabs-container') ?
                createPortal(<CustomerTypeFilter
                    handleFilter={handleFilter}
                    filter={props.filter}
                    showCustomerType={props.showCustomerType}
                    showStatuses={props.showStatuses}
                    handleSearch={props.handleSearch}

                />, document.querySelector('.mini-tabs-container'))
                :
                <>
                </>
            }


            <div className="col" data-id="3">
                <input
                    type="search"
                    name="name"
                    onKeyUp={handleSearch}
                    onChange={handleSearch}
                    value={props.filter.name}
                    placeholder={trans('labels.search')}
                />
            </div>
            {/* <div className="col">
                <label>
                            {trans('filters.filterBy')}
                        </label>
                <select onChange={handleSelectMobileFilter}>
                    <option value="1" selected>
                        {trans('filters.category')}
                    </option>
                    <option value="2">
                        {trans('labels.supplier')}
                    </option>
                    <option value="3">
                        {trans('labels.search')}
                    </option>
                    {props.showDates ?
                        <>
                            <option value="4">
                                {trans('labels.dateFrom')}
                            </option>
                            <option value="5">
                                {trans('labels.finalDate')}
                            </option>
                        </>
                        :
                        ''
                    }
                </select>
            </div> */}

            <div className="col" data-id="1">
                <Dropdown
                    inputIdValue={Number(props.filter.category_id)}
                    url="partners/categories/all"
                    renderText={data => {
                        return data.name
                    }}
                    onChange={data => {
                        handleCategory(data)
                    }}
                    inputPlaceholder={trans('labels.category')}
                    ref={categoriesDropdownRef}
                />
            </div>
            <div className="col" data-id="2">
                <Dropdown
                    inputIdValue={Number(props.filter.supplier_id)}
                    url="suppliers/all"
                    renderText={data => {
                        return data.name
                    }}
                    onChange={data => {
                        handleSupplier(data)
                    }}
                    inputPlaceholder={trans('labels.supplier')}
                    ref={suppliersDropdownRef}
                />
            </div>
            {props.showDates &&
                <DateRange
                    startDate={props.filter.start}
                    endDate={props.filter.end}
                    onStartDateChange={(date) => {
                        props.handleSearch('start', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('end', date)
                    }}
                />
            }

            {(props.filter.stock === 'office' || props.filter.stock === 'appliances') &&
                <>
                    <div className="col">
                        <Dropdown
                            inputIdValue={Number(props.filter.storage_id)}
                            url="storages/all"
                            onChange={data => {
                                handleStorage(data)
                            }}
                            inputPlaceholder={trans('labels.storage')}
                            ref={storagesDropdownRef}
                        />
                    </div>
                    <div className="col">
                        <Dropdown
                            inputValue={String(props.filter.box)}
                            url="storage/boxes"
                            onChange={data => {
                                handleBox(data)
                            }}
                            inputPlaceholder={trans('labels.box')}
                            ref={boxesDropdownRef}
                        />
                    </div>
                </>
            }
            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    {trans('buttons.clearFilter')}
                </button>
            </div>
        </form>
    )
}

export default Filter